export default {
  example: {
    text: 'EN translate',
  },
};
